<div class="container-fluid py-1 no-underline">
  <div class="container pt-5 pb-3">
    <h1 class="display-4 text-uppercase text-center mb-5">
      Nuestros Servicios
    </h1>
    <div class="grid">
      <!-- Cambio clave: grid sin justify-content-center para usar todo el ancho -->
      <div class="col-12 sm:col-6 lg:col-4 mb-3">
        <!-- Ajuste de breakpoints -->
        <div class="service-item rounded p-4 p-lg-5 mb-3 h-full">
          <!-- Padding responsive y altura completa -->
          <div class="content h-full">
            <div class="front h-full">
              <div class="front-content flex flex-column justify-content-center align-items-center h-full w-full">
                <i class="fa fa-3x fa-users text-primary mb-3 mb-lg-4"></i>
                <h4 class="text-uppercase mb-3 mb-lg-4 text-center">
                  Individuos y familias
                </h4>
                <p class="m-0 text-center services">Wealth Management</p>
              </div>
            </div>
            <div class="back h-full">
                <div class="back-content h-full flex flex-column justify-content-center"> <!-- Añadido flex y justify-content-center -->
                <ul class="text-left pl-0 mx-auto">
                  <li>Planificación financiera personal</li>
                  <li>Inversiones en pesos y dólares</li>
                  <li>Protección patrimonial</li>
                  <li>Educación financiera</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Repetir misma estructura para las otras 2 cards -->
      <div class="col-12 sm:col-6 lg:col-4 mb-3">
        <div class="service-item rounded p-4 p-lg-5 mb-3 h-full">
          <div class="content h-full">
            <div class="front h-full">
              <div class="front-content flex flex-column justify-content-center align-items-center h-full w-full">
                <i class="fa fa-3x fa-industry text-primary mb-3 mb-lg-4"></i>
                <h4 class="text-uppercase mb-3 mb-lg-4 text-center">
                  PyMEs y emprendedores
                </h4>
                <p class="m-0 text-center services">Soluciones pensadas para vos</p>
              </div>
            </div>
            <div class="back h-full">
              <div class="back-content h-full flex flex-column justify-content-center"> <!-- Añadido flex y justify-content-center -->
                <ul class="text-left pl-0 mx-auto">
                  <li>Acceso a financiamiento (SGR, cheques, pagarés, ONs)</li>
                  <li>Optimización de estructura financiera</li>
                  <li>Gestión de excedentes de caja</li>
                  <li>Diagnóstico económico-financiero</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 sm:col-6 lg:col-4 mb-3">
        <div class="service-item rounded p-4 p-lg-5 mb-3 h-full">
          <div class="content h-full">
            <div class="front h-full">
              <div class="front-content flex flex-column justify-content-center align-items-center h-full w-full">
                <i class="fa fa-3x fa-building text-primary mb-3 mb-lg-4"></i>
                <h4 class="text-uppercase mb-3 mb-lg-4 text-center">
                  Soluciones corporativas
                </h4>
                <p class="m-0 text-center services">Servicios corporativos</p>
              </div>
            </div>
            <div class="back h-full">
              <div class="back-content h-full flex flex-column justify-content-center"> <!-- Añadido flex y justify-content-center -->
                <ul class="text-left pl-0 mx-auto">
                  <li>Asesoría estratégica</li>
                  <li>Finanzas para la toma de decisiones</li>
                  <li>Apoyo al área contable/administrativa</li>
                  <li>Talleres y capacitaciones</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>